import { inject, injectable } from 'inversify-props';
import { IHttpClient, ILogger, ISettings } from '../common';
import { ProImage, PagedResult } from '../../models';


export interface IProImageService {

	get(proId: string, imageId: string): Promise<ProImage>;
	list(proId: string): Promise<ProImage[]>;
	page(proId: string, pageIndex: number, pageSize: number): Promise<PagedResult<ProImage>>;
	save(image: ProImage): Promise<ProImage>;
	delete(proId: string, imageId: string): Promise<any>;
	revert(proId: string): Promise<any>;
}

@injectable()
export class ProImageService implements IProImageService {


	constructor(
		@inject('IHttpClient') private httpClient: IHttpClient,
		@inject('ILogger') private logger: ILogger,
		@inject('ISettings') private settings: ISettings) {}


	public get(proId: string, imageId: string): Promise<ProImage> {
		const url = `${this.settings.baseUrl}${this.settings.proBaseUrl}/${proId}/images/${imageId}`;
		return this.httpClient.get<ProImage>(url);
	}

	public list(proId: string): Promise<ProImage[]> {
		const url = `${this.settings.baseUrl}${this.settings.proBaseUrl}/${proId}/images`;
		return this.httpClient.get<ProImage[]>(url);
	}

	public page(proId: string, pageIndex: number, pageSize: number): Promise<PagedResult<ProImage>> {
		const url = `${this.settings.baseUrl}${this.settings.proBaseUrl}/${proId}/images/${pageIndex}/${pageSize}`;
		return this.httpClient.get<PagedResult<ProImage>>(url);
	}

	public save(image: ProImage): Promise<ProImage> {
		let url = `${this.settings.baseUrl}${this.settings.proBaseUrl}/${image.proId}/images`;
		if (image.id !== null && image.id !== undefined && image.id !== '') {
			url += `/${image.id}`;
			return this.httpClient.put(url, image);
		}
		return this.httpClient.post(url, image);
	}

	public delete(proId: string, imageId: string): Promise<any> {
		const url = `${this.settings.baseUrl}${this.settings.proBaseUrl}/${proId}/images/${imageId}`;
		return this.httpClient.delete(url);
	}

	public revert(proId: string): Promise<any> {
		const url = `${this.settings.baseUrl}${this.settings.proBaseUrl}/${proId}/images/revert`;
		return this.httpClient.post(url, null);
	}

}
